import { createAction } from "@reduxjs/toolkit"

export const LOGIN = "LOGIN"
export const REQUEST_LOGIN = "REQUEST_LOGIN"
export const REQUEST_ACCESS = "REQUEST_ACCESS"
export const FORGOT_PASSWORD = "FORGOT_PASSWORD"
export const LOGOUT = "LOGOUT"
export const LOGOUT_RTK = createAction(LOGOUT)
export const CREATE_ACCOUNT = "CREATE_ACCOUNT"
export const CHANGE_PASSWORD = "CHANGE_PASSWORD"
export const CHECK_PASSWORD_RULES = "CHECK_PASSWORD_RULES"
export const RECEIVE_INITIAL_STATE = "RECEIVE_INITIAL_STATE"
export const FETCH_INITIAL_STATE = "FETCH_INITIAL_STATE"

export const fetchInitialState = (newAccount) => ({
  type: FETCH_INITIAL_STATE,
  newAccount,
})

export const receiveInitialState = (response, newAccount) => ({
  type: RECEIVE_INITIAL_STATE,
  response,
  newAccount,
})

export const forgotPassword = (email, success, error) => ({
  type: FORGOT_PASSWORD,
  email,
  success,
  error,
})

export const checkPasswordRules = (password, success, error) => ({
  type: CHECK_PASSWORD_RULES,
  password,
  success,
  error,
})

export const requestLogin = (email, password, onboarding, success, error) => ({
  type: REQUEST_LOGIN,
  email,
  password,
  onboarding,
  success,
  error,
})

export const requestAccess = (params, success, error) => ({
  type: REQUEST_ACCESS,
  params,
  success,
  error,
})

export const login = () => ({
  type: LOGIN,
})

export const logout = () => ({
  type: LOGOUT,
})

const passwordTicket = (type) => (ticketId, firstPassword, secondPassword, success, error) => ({
  type,
  ticketId,
  firstPassword,
  secondPassword,
  success,
  error,
})

export const createAccount = passwordTicket(CREATE_ACCOUNT)
export const changePassword = passwordTicket(CHANGE_PASSWORD)
